import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from "../Home";
import Form from "../Form";
import About from "../About";
import Team from "../Team";
import Services from "../Services";
import Expertise from "../Expertise";
import Navbar from "../Navbar";
import Process from "../Process";
import "./parent.css";

class Parent extends Component {
  // Component's constructor.
  constructor(props) {
    // super(props) called to ensure that this.props is undefined in this constructor.
    super(props);
    // Setting the state for this component with empty date, time, email, and password keys.
  this.state = {
    date: "",
    time: "",
    email: "",
    password: ""
  };
}

// Function setting state of the email key.
  login(credentials) {
    this.setState({
      email: credentials
    })
  };

  // Function setting the state of the date key.
  onUpdate(dateChosen) {
    this.setState({
      date: dateChosen
    });
  };

  // Function setting the state of the time key.
  onTimeUpdate(time) {
    this.setState({
      time: time
    })
  };

  // Function ensuring that the component mounts with the updated state key value pairs.
  componentDidUpdate() {
    console.log(this.state.date);
    console.log(this.state.time);
    console.log(this.state.email)
  };



  render() {
    return (
      <div>
            <Route exact path="/" component={Home} />
            <Route exact path="/contact" component={Form} />
            <Route exact path="/mission" component={About} />
            <Route exact path="/team" component={Team} />
            <Route exact path="/process" component={Process} />
            <Route exact path="/expertise" component={Expertise} />
            <Route exact path="/navbar" component={Navbar} />
            <Route exact path="/services" component={Services} />
      </div>
    );
  }
}


export default Parent;
